import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import ProjectImg from '../img/project.png'; // Ensure the correct path
import cif from '../img/CIF VERTICAL.jpg';
import Balika from '../img/BALIKA VADHU VERTICAL.jpg'
import chandrakanta from '../img/CHANDRAKANTA VERTICAL.jpg';

const Projects = () => {
  const [progress, setProgress] = useState([0, 0, 0]);
  const [isVisible, setIsVisible] = useState(false); // State to track visibility
  const sectionRef = useRef(null); // Ref for the section

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress([85, 75, 90]);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // Set visible to true when in viewport
          observer.disconnect(); // Stop observing after the first intersection
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current); // Cleanup observer
      }
    };
  }, [sectionRef]);

  return (
    <div className="project" ref={sectionRef}>
      <motion.div 
        className="project-col" 
        initial={{ opacity: 0 }} 
        animate={{ opacity: isVisible ? 1 : 0 }} 
        transition={{ duration: 0.8 }}
      >
        <div className="project-list project-list1">
          <motion.p 
            className='round' 
            initial={{ opacity: 0 }} 
            animate={{ opacity: isVisible ? 1 : 0 }} 
            transition={{ duration: 0.5 }}
          >
            Projects
          </motion.p>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }} 
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            TOP PROJECTS
          </motion.h2>
          <motion.p 
            className='para' 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }} 
            transition={{ duration: 0.6, delay: 0.2 }}
          >
           Mazhar Khan has an impressive portfolio spanning over 30 projects in television, films, and advertisements.
          </motion.p>
        </div>
        {/* <div className="project-list">
          {['Skills', 'Best Teaching/Skills', 'Training Safety and Comfort'].map((label, index) => (
            <motion.div 
              className="progress-bar-container" 
              key={index}
              initial={{ opacity: 0, y: 10 }} 
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 10 }} 
              transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
            >
              <p>{label}</p>
              <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: `${progress[index]}%` }}>{progress[index]}%</div>
              </div>
            </motion.div>
          ))}
        </div> */}
      </motion.div>
      <motion.div 
        className="project-card" 
        initial={{ opacity: 0 }} 
        animate={{ opacity: isVisible ? 1 : 0 }} 
        transition={{ duration: 0.8 }}
      >
        {[{ img: cif, title: 'White Sand Production- cif tv show', role: 'Art Director' },
          { img: Balika, title: 'Spare Origin Production- Balika Vadhu Assistant', role: 'Art Director' },
          { img: chandrakanta, title: 'balaji telefilm ltd- Chandrakanta tv show', role: 'Assistant Art Director' }
        ].map((project, index) => (
          <motion.div 
            className="project-card-list" 
            key={index} 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 10 }} 
            transition={{ duration: 0.6, delay: 0.4 + index * 0.2 }}
          >
            <div className="project-card-img">
              <img src={project.img} alt={`Project ${index + 1}`} />
            </div>
            <div className="project-card-info">
              <h2>{project.title}</h2>
              <p>{project.role}</p>
            </div>
            {/* <div className="project-card-icons">
              <i className="fa-brands fa-instagram"></i>
              <i className="fa-brands fa-facebook"></i>
              <i className="fa-brands fa-youtube"></i>
            </div> */}
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Projects;
